import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';
import { formatImage } from '@ifeng-fe/public_method';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation, Thumbs } from 'swiper';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

const Atlas = ({ content }) => {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const imageList = content?.[0]?.intelligentImages.image.map(item => item.url);

    return (
        <div className={styles.atlas}>
            <Swiper
                loop={true}
                spaceBetween={0}
                navigation={true}
                thumbs={{ swiper: thumbsSwiper }}
                modules={[FreeMode, Navigation, Thumbs]}
                className="bigMySwiper">
                {imageList.map((item, index) => {
                    return (
                        <SwiperSlide key={index}>
                            <img className={styles.atlasPic} src={item} />
                        </SwiperSlide>
                    );
                })}
            </Swiper>
            <Swiper
                onSwiper={setThumbsSwiper}
                // loop={true}
                spaceBetween={10}
                slidesPerView={6}
                freeMode={true}
                watchSlidesProgress={true}
                modules={[FreeMode, Navigation, Thumbs]}
                className="smallMySwiper">
                {imageList.map((item, index) => {
                    return (
                        <SwiperSlide key={index}>
                            <img src={formatImage(item, 158, 107)} />
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
};

Atlas.propTypes = {
    content: PropTypes.array,
};

export default errorBoundary(Atlas);
